module.exports = __webpack_public_path__ + "img/Tele.eea0c6de.svg";